<template>
  <base-side-page
    @cancel="cancelSidePage"
    :title="$t('bill.title.origin_res_type')"
    icon="res-billoriginresourcetype"
    :res-name="getResName(detailData.origin_res_type)"
    :current-tab="params.windowData.currentTab"
    :loaded="loaded"
    :tabs="detailTabs"
    @tab-change="handleTabChange">
    <component
      :is="params.windowData.currentTab"
      :res-id="data.id"
      :id="listId"
      :data="detailData"
      :on-manager="onManager"
      :show-group-actions="false"
      :show-single-actions="false"
      :getParams="getParams"
      :hiddenKindTabs="hiddenKindTabs"
      :defaultOriginResType="defaultOriginResType"
      :defaultDate="date.dateParam"
      :defaultDateMode="date.dateMode"
      :defaultDataType="date.dateParam.data_type"
      :showBillShared="true"
      @tab-change="handleTabChange" />
  </base-side-page>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
import Overview from '@Bill/views/overview/components'
import SidePageMixin from '@/mixins/sidePage'
import WindowsMixin from '@/mixins/windows'
import ColumnsMixin from '../mixins/columns'

export default {
  name: 'BillOriginResourcetypeSidePage',
  components: {
    Overview,
  },
  mixins: [SidePageMixin, WindowsMixin, ColumnsMixin],
  data () {
    return {
      detailTabs: [
        { label: this.$t('bill.budget_alert_type_cost'), key: 'overview' },
      ],
    }
  },
  computed: {
    ...mapGetters(['isDomainMode', 'scope']),
    listId () {
      switch (this.params.windowData.currentTab) {
        case 'overview':
          return 'OverviewForBillOriginResourceTypeSidePage'
        default:
          return ''
      }
    },
    getParams () {
      return {}
    },
    defaultOriginResType () {
      return this.listRowData.origin_res_type
    },
    hiddenKindTabs () {
      if (this.isDomainMode) {
        return ['domain', 'origin-res-type', 'external_project']
      } else if (this.isProjectMode) {
        return ['domain', 'project', 'origin-res-type', 'external_project']
      }
      return ['origin-res-type', 'external_project']
    },
    date () {
      const dateParam = _.get(this.params, 'options.dateParam') || {}
      const dateMode = _.get(this.params, 'options.dateMode') || ''
      return { dateParam, dateMode }
    },
  },
  methods: {
    getResName (name) {
      // if (this.$te(`bill_resource_type.${name}`)) {
      //  return this.$t(`bill_resource_type.${name}`)
      // }
      return name
    },
  },
}
</script>
